import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  customers: [],
  error: null,
  isLoading: false
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    // General loading state for any request
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    // General failure state for any request
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    // Fetch all customers success
    fetchAllCustomersSuccess: (state, action) => {
      state.customers = action.payload;
      state.isLoading = false;
    },
    // Fetch customer info success
    getCustomerInfoSuccess: (state, action) => {
      state.currentCustomer = action.payload;
      state.isLoading = false;
    },
    // Add new customer success
    addCustomerSuccess: (state, action) => {
      state.customers = [...state.customers, action.payload];
      state.isLoading = false;
    },

    // Update customer info
    updateCustomerInfoSuccess: (state, action) => {
      const updated = action.payload;
      const index = state.customers.findIndex(
        c => c.user.id === updated.userId
      );

      if (index !== -1) {
        const existing = state.customers[index].user;
        state.customers[index].user = {
          ...existing,
          ...updated,
          customerName: `${updated.firstName || existing.firstName} ${
            updated.lastName || existing.lastName
          }`.trim()
        };
      }

      state.isLoading = false;
    },

    //Update customer balance
    updateCustomerBalanceSuccess: (state, action) => {
      const { userId, balance } = action.payload;
      const index = state.customers.findIndex(c => c.user.id === userId);

      if (index !== -1) {
        state.customers[index].user.balance = balance;
      }

      state.isLoading = false;
    },

    //Update customer deposit
    updateCustomerDepositSuccess: (state, action) => {
      const { id, amount } = action.payload;
      const index = state.customers.findIndex(c => c.user.id === id);

      if (index !== -1) {
        state.customers[index].user.deposit = amount;
      }

      state.isLoading = false;
    },

    //Delete customer
    deleteUserSuccess: (state, action) => {
      const deletedId = action.payload;
      state.customers = state.customers.filter(
        customer => customer.user.id !== deletedId
      );
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchAllCustomersSuccess,
  getCustomerInfoSuccess,
  addCustomerSuccess,
  updateCustomerInfoSuccess,
  updateCustomerBalanceSuccess,
  updateCustomerDepositSuccess,
  deleteUserSuccess
} = customerSlice.actions;

export default customerSlice.reducer;
